import PropTypes from 'prop-types';
import React from 'react';
// import { generateAppPath } from 'epic-common/src/route';

class AboutBlock extends React.Component {
    static propTypes = {
        bgImage: PropTypes.string,
        subTitle1: PropTypes.string,
        title: PropTypes.string,
        logo: PropTypes.string,
        description: PropTypes.string
    }

    render() {
        // const homeLink = generateAppPath('/home');
        const {
            bgImage, subTitle1, title, logo, description
        } = this.props;
        const style = {
            backgroundImage: `url(${bgImage})`
        };
        return (
            <section className="about">
                <div
                    className="grid"
                    style={style}>
                    {// eslint-disable-next-line react/no-danger
                    }<div className="headline" dangerouslySetInnerHTML={{__html: title}} />
                    <div className="vertical-title">{subTitle1}</div>
                    <div className="copy">
                        <img alt="logo" src={logo} className="hide-mobile-only" />
                        {// eslint-disable-next-line react/no-danger
                        }<p dangerouslySetInnerHTML={{__html: description}} />
                    </div>
                </div>
            </section>
        );
    }
}

export default AboutBlock;
